import React from 'react'
import {  Image} from 'semantic-ui-react'

// const LoaderExampleInlineCentered = () => <Loader active inline='centered' size='large' >Loading</Loader>
const LoaderExampleInlineCentered = () => <React.Fragment>
    <Image src={`/assets/images/BeanEater.gif`} />
</React.Fragment>
export default LoaderExampleInlineCentered


// WEBPACK FOOTER //
// ./src/app/components/features/share/loadingInline.js